module.exports = __webpack_public_path__ + "assets/img/1807.1742ac0d.png";